var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"layout layout--registration"},[_c('l-r-header'),_c('router-view'),_c('l-footer',{attrs:{"theme":'white'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }